import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import getBaseQueryWithReauth from '../../../utils/api/query-auth';
import { handleContacts } from '../../slices/backoffice/backofficeCompanyContactsSlice';
import getAuth from '../../../utils/api/getToken';

const baseQuery = fetchBaseQuery({
  baseUrl: `${process.env.REACT_APP_API_BASE_URL}/Company`,
  prepareHeaders: (headers) => {
    const token = getAuth();
    if (token) {
      headers.set('authorization', `Bearer ${token.auth}`);
    }
    return headers;
  },
});

export const backofficeContactApi: any = createApi({
  reducerPath: 'backofficeContact',
  baseQuery: getBaseQueryWithReauth(baseQuery),
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getCompanyContacts: builder.query({
      query: (companyDatabaseId) => {
        return {
          url: '/getCompanyContacts',
          params: { companyDatabaseId },
        };
      },
      async onQueryStarted(_arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(
            handleContacts({
              data: data?.data,
              status: data.status,
              path: data?.path,
              message: data?.message,
            }),
          );
        } catch {
          console.error('Error in getting BackofficeContact data');
        }
      },
    }),
    putUpdateContact: builder.mutation({
      query: (body) => ({
        url: `/updateCompanyContacts`,
        method: 'PUT',
        body,
      }),
    }),
    postCreateContact: builder.mutation({
      query: (body) => ({
        url: `/addCompanyContacts`,
        method: 'POST',
        body,
      }),
    }),
    deleteContact: builder.mutation({
      query: (body) => ({
        url: `/deleteCompanyContacts`,
        method: 'DELETE',
        body,
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetCompanyContactsQuery,
  usePutUpdateContactMutation,
  usePostCreateContactMutation,
  useDeleteContactMutation,
} = backofficeContactApi;
